"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputRelation = _interopRequireDefault(require("../InputRelation"));
var _InputString = _interopRequireDefault(require("../InputString"));
var _InputPassword = _interopRequireDefault(require("../InputPassword"));
var _InputNumber = _interopRequireDefault(require("../InputNumber"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _InputJson = _interopRequireDefault(require("../InputJson"));
var _InputImage = _interopRequireDefault(require("../InputImage"));
var _InputFile = _interopRequireDefault(require("../InputFile"));
var _InputSignature = _interopRequireDefault(require("../InputSignature"));
var _InputPointer = _interopRequireDefault(require("../InputPointer"));
var _InputSelect = _interopRequireDefault(require("../InputSelect"));
var _InputIcon = _interopRequireDefault(require("../InputIcon"));
var _RelatedFactory = _interopRequireDefault(require("../RelatedFactory"));
var _InputBoolean = _interopRequireDefault(require("../InputBoolean"));
var _Input = _interopRequireDefault(require("../Input"));
var _getPropertyByPath = _interopRequireDefault(require("../getPropertyByPath"));
var _setObjectByPath = _interopRequireDefault(require("../setObjectByPath"));
var _InputCurrency = _interopRequireDefault(require("../InputCurrency"));
var _InputPhone = _interopRequireDefault(require("../InputPhone"));
var _InputOTP = _interopRequireDefault(require("../InputOTP"));
var _InputMeasurement = _interopRequireDefault(require("../InputMeasurement"));
var _excluded = ["type", "_type", "field", "object", "schemas", "onChange", "required", "onProps"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputFactory/index.js";
var defaultProps = {
  schemas: []
};
function InputFactory(_ref) {
  var type = _ref.type,
    _type = _ref._type,
    field = _ref.field,
    object = _ref.object,
    schemas = _ref.schemas,
    onChange = _ref.onChange,
    required = _ref.required,
    onProps = _ref.onProps,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var reference = props.reference && (0, _getPropertyByPath["default"])(object, props.reference);
  var value = reference || object && object[field];
  if (typeof onProps === "function") {
    props = onProps(props, object, field) || props;
  }
  var _onChange = function _onChange(field, value) {
    if (object) {
      (0, _setObjectByPath["default"])(object, props.reference || field, value);
      if (props.reference) {
        var change = {};
        field = (0, _setObjectByPath["default"])(change, props.reference, value);
        value = change[field];
      }
    }
    onChange(value, field);
  };
  type = _type || type;
  switch (type) {
    case "Email":
    case "String":
      return /*#__PURE__*/_react["default"].createElement(_InputString["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        type: type.toLowerCase(),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 9
        }
      }));
    case "Password":
    case "InputPassword":
      return /*#__PURE__*/_react["default"].createElement(_InputPassword["default"], Object.assign({
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 9
        }
      }));
    case "Number":
    case "Tel":
      return /*#__PURE__*/_react["default"].createElement(_InputNumber["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 9
        }
      }));
    case "Text":
    case "InputText":
      return /*#__PURE__*/_react["default"].createElement(_InputText["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91,
          columnNumber: 9
        }
      }));
    case "Relation":
      return /*#__PURE__*/_react["default"].createElement(_InputRelation["default"], Object.assign({
        field: field,
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100,
          columnNumber: 9
        }
      }));
    case "Pointer":
      var schema = props.schema || schemas.find(function (s) {
        return s.collection === props.target;
      });
      if (!schema) return null;
      return /*#__PURE__*/_react["default"].createElement(_InputPointer["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117,
          columnNumber: 9
        }
      }));
    case "Related":
    case "InputRelated":
      return /*#__PURE__*/_react["default"].createElement(_RelatedFactory["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        field: field,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131,
          columnNumber: 9
        }
      }));
    case "Image":
    case "InputImage":
      return /*#__PURE__*/_react["default"].createElement(_InputImage["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146,
          columnNumber: 9
        }
      }));
    case "File":
    case "InputFile":
      return /*#__PURE__*/_react["default"].createElement(_InputFile["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 9
        }
      }));
    case "InputSignature":
    case "Signature":
      return /*#__PURE__*/_react["default"].createElement(_InputSignature["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 9
        }
      }));
    case "Boolean":
      return /*#__PURE__*/_react["default"].createElement(_InputBoolean["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        field: field,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175,
          columnNumber: 9
        }
      }));
    case "Object":
    case "Array":
      return /*#__PURE__*/_react["default"].createElement(_InputJson["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186,
          columnNumber: 9
        }
      }));
    case "Enum":
    case "InputSelect":
      return /*#__PURE__*/_react["default"].createElement(_InputSelect["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        placeholder: props.placeholder || (props.dynamic ? "Select of type " : "Select ") + (props.label || field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 9
        }
      }));
    case "Icon":
    case "InputIcon":
      return /*#__PURE__*/_react["default"].createElement(_InputIcon["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 211,
          columnNumber: 9
        }
      }));
    case "Date":
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        type: type.toLowerCase(),
        defaultValue: value && value.slice(0, 10),
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 220,
          columnNumber: 9
        }
      }));
    case "Color":
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        className: "form-control-color",
        type: type.toLowerCase(),
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 230,
          columnNumber: 9
        }
      }));
    case "Currency":
    case "InputCurrency":
      return /*#__PURE__*/_react["default"].createElement(_InputCurrency["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 242,
          columnNumber: 9
        }
      }));
    case "Phone":
    case "InputPhone":
      return /*#__PURE__*/_react["default"].createElement(_InputPhone["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 252,
          columnNumber: 9
        }
      }));
    case "OTP":
    case "InputOTP":
      return /*#__PURE__*/_react["default"].createElement(_InputOTP["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field)
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 262,
          columnNumber: 9
        }
      }));
    case "Measurement":
    case "InputMeasurement":
      return /*#__PURE__*/_react["default"].createElement(_InputMeasurement["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 271,
          columnNumber: 9
        }
      }));
    default:
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        type: type.toLowerCase(),
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 280,
          columnNumber: 9
        }
      }));
  }
}
InputFactory.defaultProps = defaultProps;
var _default = exports["default"] = InputFactory;